import { useDfContext } from '../context/df-context';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getConfig } from '../utils/config';
import { search } from '../api/search';
import { CACHE_TIME } from '../constants';
import { FilterName } from '../types';

const pimLanguage = getConfig('pim_language', 'en');
const cmsNativeLanguage = getConfig('cms_native_language', 'EN-EN');

export function useFilterCountPreview(
  localSelection: string[],
  filterName: FilterName,
  enabled = true,
) {
  const {
    state: { itemFilter, preFilter, term, selected },
  } = useDfContext();

  const filterMapper = {
    filetypes: 'filterType',
    languages: 'filterLanguage',
    variant: 'filterVariant',
  };

  const queryParams = {
    params: Object.entries(selected).map(([depth, pimId]) => ({
      depth: parseInt(depth, 10),
      pimId,
    })),
    cmsNativeLanguage,
    pimLanguage,
    filterType: itemFilter?.fileType,
    filterLanguage: itemFilter?.language,
    filterVariant: itemFilter?.variants,
    searchObject: preFilter,
    term: term,
    rows: 0,
    [filterMapper[filterName]]: localSelection,
  };

  const { data, isLoading, isError } = useQuery({
    queryKey: [itemFilter, preFilter, localSelection, term, selected],
    queryFn: async () => {
      return await search(queryParams);
    },
    staleTime: Infinity,
    gcTime: CACHE_TIME,
    retry: false,
    placeholderData: keepPreviousData,
    enabled: enabled,
  });

  return [data?.data?.searchResult.numFound, isLoading, isError];
}
